<template>
    <div class="box-layout">
        <img v-if="this.logo === 'connect'" src="@/assets/images/logo.png" class="w-100 mb-4" />
        <img v-if="this.logo === 'lab'" src="@/assets/images/transparent-1000.png" class="w-100 mb-4" />
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            logo: {
                default: 'connect',
            }
        },
    }
</script>

<style scoped type="text/css">
    .box-layout
    {
        max-width: 400px;
        width: 100%;
        margin: auto;
        margin-top: 10vh;
    }
</style>